import BaseClass from 'components/BaseClass/BaseClass';

export default BaseClass;
